import {BrickContext, ActionBrick, registerBrick } from 'olympe';
import Module from 'openaistreammodule';

export default class StreamAudioToText extends ActionBrick {

    static instance;
    static context;
    static mediaRecorder;
    static kSampleRate = 16000;
    static kRestartRecording_s = 120;
    static kIntervalAudio_ms = 5000;

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} language
     * @param {function()} forwardEvent
     * @param {function(string)} setIsRecording
     * @param {function(Array)} setTexts
     */
    update($, [language], [forwardEvent, setIsRecording, setTexts]) {

        const isRecording = $.get('is-recording') ?? false;

        if (!StreamAudioToText.instance) {
            StreamAudioToText.instance = Module.init('whisper.bin', language);

            if (StreamAudioToText.instance) {
                console.log("js: whisper initialized, instance: " + StreamAudioToText.instance);
            }
        }

        if (!StreamAudioToText.instance) {
            console.error("js: failed to initialize whisper");
            return;
        }


        if (isRecording === false) {
            this.startRecording($);
        } else {
            this.stopRecording($);
        }

        if($.get('is-recording')) {
            const texts = [];
            const intervalUpdate = setInterval(function () {
                if ($.get('is-recording') === false) {
                    clearInterval(intervalUpdate);
                    return;
                }
                const transcribed = Module.get_transcribed();

                if (transcribed != null && transcribed.length > 1) {
                    texts.push(transcribed);
                    setTexts([...texts]);
                }
            }, 100);
            $.onDestroy(() => clearInterval(intervalUpdate));
        }

        setIsRecording($.get('is-recording'));
        forwardEvent();
    }


    startRecording($) {
        if (!StreamAudioToText.context) {
            StreamAudioToText.context = new AudioContext({
                sampleRate: StreamAudioToText.kSampleRate,
                channelCount: 1,
                echoCancellation: false,
                autoGainControl:  true,
                noiseSuppression: true,
            });
        }

        Module.set_status("");

        $.set('is-recording', true);

        const chunks = [];
        let stream = null;

        navigator.mediaDevices.getUserMedia({audio: true, video: false})
            .then((s) => {
                stream = s;
                StreamAudioToText.mediaRecorder = new MediaRecorder(stream);
                StreamAudioToText.mediaRecorder.ondataavailable = (e) => {
                    chunks.push(e.data);

                    const blob = new Blob(chunks, { 'type' : 'audio/ogg; codecs=opus' });
                    const reader = new FileReader();

                    reader.onload = () => {
                        const buf = new Uint8Array(reader.result);

                        if (!StreamAudioToText.context) {
                            return;
                        }
                        StreamAudioToText.context.decodeAudioData(buf.buffer, (audioBuffer) => {
                            const offlineContext = new OfflineAudioContext(audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate);
                            const source = offlineContext.createBufferSource();
                            source.buffer = audioBuffer;
                            source.connect(offlineContext.destination);
                            source.start(0);

                            offlineContext.startRendering().then((renderedBuffer) => {
                                StreamAudioToText.audio = renderedBuffer.getChannelData(0);

                                //printTextarea('js: audio recorded, size: ' + audio.length + ', old size: ' + (audio0 == null ? 0 : audio0.length));

                                const audioAll = new Float32Array(StreamAudioToText.audio0 == null ? StreamAudioToText.audio.length : StreamAudioToText.audio0.length + StreamAudioToText.audio.length);
                                if (StreamAudioToText.audio0 != null) {
                                    audioAll.set(StreamAudioToText.audio0, 0);
                                }
                                audioAll.set(StreamAudioToText.audio, StreamAudioToText.audio0 == null ? 0 : StreamAudioToText.audio0.length);

                                if (StreamAudioToText.instance) {
                                    Module.set_audio(StreamAudioToText.instance, audioAll);
                                }
                            });
                        }, () => {
                            StreamAudioToText.audio = null;
                        });
                    }

                    reader.readAsArrayBuffer(blob);
                };

                StreamAudioToText.mediaRecorder.onstop = () => {
                    if ($.get('is-recording')) {
                        setTimeout(() => {
                            this.startRecording($);
                        });
                    }
                };

                StreamAudioToText.mediaRecorder.start(StreamAudioToText.kIntervalAudio_ms);
            })
            .catch((err) => {
                console.error('js: error getting audio stream: ' + err);
            });

        const interval = setInterval(() => {
            if (!$.get('is-recording')) {
                clearInterval(interval);
                StreamAudioToText.mediaRecorder.stop();
                stream.getTracks().forEach((track) => {
                    track.stop();
                });

                StreamAudioToText.mediaRecorder = null;
            }

            // if audio length is more than kRestartRecording_s seconds, restart recording
            if (StreamAudioToText.audio != null && StreamAudioToText.audio.length > StreamAudioToText.kSampleRate*StreamAudioToText.kRestartRecording_s) {
                if ($.get('is-recording')) {
                    //printTextarea('js: restarting recording');

                    clearInterval(interval);
                    StreamAudioToText.audio0 = StreamAudioToText.audio;
                    StreamAudioToText.audio = null;
                    StreamAudioToText.mediaRecorder.stop();
                    stream.getTracks().forEach((track) => {
                        track.stop();
                    });
                }
            }
        }, 100);

        $.onDestroy(() => {
            clearInterval(interval);
            StreamAudioToText.audio0 = StreamAudioToText.audio;
            StreamAudioToText.audio = null;
            StreamAudioToText.mediaRecorder.stop();
            stream.getTracks().forEach((track) => {
                track.stop();
            });
        });
    }


    stopRecording($) {
        Module.set_status("paused");
        $.set('is-recording', false);
        StreamAudioToText.audio0 = null;
        StreamAudioToText.audio = null;
        StreamAudioToText.context = null;
    }
}

registerBrick('0190dbe7264d3ddb5291', StreamAudioToText);
